import React, { FC } from 'react';
import { useHistory, useLocation, useParams } from 'react-router-dom';

import DetailSlider from 'components/DetailSlider';

import { COLORS } from 'styles/constants';
import { useGetDetailCard } from 'graphQL/card/helpers/hooks';
import { useEveryoneItemsList } from 'graphQL/cards/exploreCards/hooks';
import { useNavigationRef } from 'components/Navigation/helpers/hooks';
import { getEveryoneTime } from 'components/Explore/Item/helpers';
import { transformRoute } from 'helpers/routingHelper';
import { ROUTE_EVERYONE_CARD_DETAIL } from 'routes';

const time = getEveryoneTime();

const EveryoneItem: FC = () => {
  const { pickId } = useParams<{ pickId: string }>();
  const { state } = useLocation<{ listUpdateTime: string } | undefined>();
  const { listUpdateTime } = state ?? {};

  const { items, loadMore } = useEveryoneItemsList(listUpdateTime ?? time);

  const { card } = useGetDetailCard(pickId);
  const { replace } = useHistory();

  const handleRoute = (id: string) =>
    replace({
      pathname: transformRoute(ROUTE_EVERYONE_CARD_DETAIL, { pickId: id }),
      state,
    });

  useNavigationRef(COLORS.white[100]);

  return items.length && card ? (
    <DetailSlider handleLoadItems={loadMore} handleRoute={handleRoute} card={card} items={items} />
  ) : null;
};

export default EveryoneItem;
